import { formatUSD } from "@/lib/api";

const Line = ({ label, value, testId, accent = "text-slate-100" }) => (
  <div className="flex items-baseline justify-between gap-4 py-2 border-b border-dashed border-slate-800">
    <span className="font-mono text-xs uppercase tracking-wider text-slate-500">{label}</span>
    <span className={`font-mono ${accent}`} data-testid={testId}>{value}</span>
  </div>
);

export const QuotePanel = ({ quote, baseCharge, rate }) => (
  <div className="border glow-green bg-[#04090C] p-5 sm:p-6" data-testid="quote-panel">
    <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#00FF66]">// estimate</p>
    <div className="mt-4">
      <Line label="Distance" testId="calculated-distance-miles"
        value={quote ? `${quote.distance_miles.toFixed(1)} mi${quote.distance_method === "manual" ? " (entered)" : ""}` : "—"} />
      <Line label="Base service charge" testId="quote-base-fee" value={formatUSD(quote?.base_charge ?? baseCharge)} />
      <Line label={`Distance @ ${formatUSD(quote?.per_mile_rate ?? rate)}/mi`} testId="quote-mileage-fee"
        value={quote ? formatUSD(quote.variable_cost) : "—"} />
    </div>
    <div className="mt-5 flex items-end justify-between">
      <span className="font-mono text-xs uppercase tracking-wider text-slate-400">Total estimate</span>
      <span className="font-mono text-3xl sm:text-4xl text-[#00FF66] text-glow-green" data-testid="live-total-price-estimate">
        {quote ? formatUSD(quote.total) : "$—"}
      </span>
    </div>
    <p className="mt-4 text-[11px] text-slate-600">Route distance © OpenStreetMap contributors · routing by OSRM</p>
  </div>
);
